import { defineStore } from 'pinia';
import FetchService from 'ewi-ui-helpers/fetchService';
import type { PostcodeResponse } from 'ewi-ui-helpers/types';
interface SuggestionListState {
  suggestions: string[] | null;
  error: string | null;
  errors: Map<string, string | boolean>;
}
// todo: refactor this at some point, or completely remove this store
export const suggestionListStore = defineStore('suggestionList', {
  state: (): SuggestionListState => ({
    suggestions: null,
    error: null,
    errors: new Map<string, string | boolean>(),
  }),
  getters: {},
  actions: {
    async getSuggestionFromZipCode(zipCode: string): Promise<string[]> {
      this.error = null;

      const result: PostcodeResponse = (await FetchService.get(
        `/ewi_api/order/validation/postcode?postcode=${zipCode}&country=DE`,
      )) as PostcodeResponse;
      if (!result) {
        return [];
      }
      if (result.code === 400 && result.message) {
        this.error = result.message;
        this.errors.set(zipCode, result.message);
      }
      if (result.result?.city?.length! > 0) {
        return result.result.city!;
      }
      return [];
    },
    getErrorForCode(code: string): string | boolean {
      return this.errors.get(code) ?? false;
    },
  },
});

// a refactor should be done here - this is a better way to represent the store
// accordingly, zipcodewithautocomplete.vue should be refactored to use this store

// export const useSuggestionListStore = defineStore('suggestionList', () => {
//   const suggestions = ref<string[]>([]);
//   const error = ref<string | null>(null);

//   const hasSuggestions = computed(
//     () => suggestions.value !== null && suggestions.value.length > 0,
//   );

//   async function getSuggestionFromZipCode(zipCode: string) {
//     error.value = null;

//     const result: Response = await FetchService.get(
//       `/ewi_api/order/validation/postcode?postcode=${zipCode}&country=DE`,
//     );

//     if (result.status === 'error' && result.messages?.length) {
//       error.value = result.messages[0];
//       suggestions.value = [];
//       return;
//     }

//     suggestions.value = result.result?.city ?? [];
//   }

//   return {
//     suggestions,
//     error,
//     hasSuggestions,
//     getSuggestionFromZipCode,
//   };
// });
